import { render, staticRenderFns } from "./TableExpandeSub.vue?vue&type=template&id=3387e46e&scoped=true&"
import script from "./TableExpandeSub.vue?vue&type=script&lang=js&"
export * from "./TableExpandeSub.vue?vue&type=script&lang=js&"
import style0 from "./TableExpandeSub.vue?vue&type=style&index=0&id=3387e46e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3387e46e",
  null
  
)

export default component.exports